module.exports = __webpack_public_path__ + "img/gift-fill.7526e95b.svg";